import {storage, StorageKeys} from '../storage';
import {ApiEnvironments, SettingParams} from './config.model';
import {settings as settingsProd} from './config.prod';
import {settings as settingsTest} from './config.tst';
import {store} from '../../app';
import {contentSlice} from '../../redux/reducers/resources/content';
import {sovkomInitialData} from '../../redux/reducers/resources/content/sovkom.test';

export class Settings {
  private static environment = ApiEnvironments.prod;
  private static settings: SettingParams = settingsProd;

  public static setSettings(environment: ApiEnvironments) {
    Settings.environment = environment;
    storage.setItem(StorageKeys.api, Settings.environment === ApiEnvironments.prod ? '' : Settings.environment);
    if (Settings.environment !== ApiEnvironments.prod)
      store.dispatch(contentSlice.actions.setContent(sovkomInitialData));

    switch (environment) {
      case ApiEnvironments.test:
        Settings.settings = settingsTest;
        break;
      default:
        Settings.settings = settingsProd;
    }
  }

  public static getSettings() {
    return Settings.settings;
  }

  public static getIsTest() {
    return Settings.environment === ApiEnvironments.test;
  }

  public static clear() {
    Settings.settings = settingsProd;
    Settings.environment = ApiEnvironments.prod;
  }
}
